export const enum MimeType {
  ApplicationJson = "application/json"
}

export const enum HttpHeader {
  Accept = "Accept",
  Authorization = "Authorization",
  ContentType = "Content-Type"
}
